import React, { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { tableHead, tableCell } from "./waShared";

function AuditLogPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [eventFilter, setEventFilter] = useState("user.updated");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ limit: "150" });
      if (eventFilter) params.set("event", eventFilter);
      const r = await api.get(`/auth/audit-logs?${params.toString()}`);
      setItems(r.data?.items || []);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "تعذّر جلب سجل التدقيق");
    } finally { setLoading(false); }
  }, [eventFilter]);
  useEffect(() => { load(); }, [load]);

  const EVENT_OPTS = [
    { v: "user.updated",  label: "تعديل صلاحيات/مستخدم" },
    { v: "user.created",  label: "إضافة مستخدم" },
    { v: "user.deleted",  label: "حذف مستخدم" },
    { v: "login.success", label: "تسجيل دخول ناجح" },
    { v: "login.failed",  label: "محاولة دخول فاشلة" },
    { v: "",              label: "كل الأحداث" },
  ];

  return (
    <div data-testid="wa-audit-panel">
      <div className="card" style={{ padding: 12, marginBottom: 10, display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
        <div style={{ fontSize: 12.5, fontWeight: 700, color: "var(--brown-deep)" }}>🛡 سجل تدقيق الصلاحيات</div>
        <select value={eventFilter} onChange={(e) => setEventFilter(e.target.value)}
          className="sim-input" style={{ minWidth: 200, fontSize: 12.5 }}
          data-testid="wa-audit-event-filter">
          {EVENT_OPTS.map((o) => <option key={o.v} value={o.v}>{o.label}</option>)}
        </select>
        <button type="button" onClick={load} className="btn btn-soft" style={{ fontSize: 12 }} data-testid="wa-audit-refresh">
          🔄 تحديث
        </button>
        <div style={{ marginInlineStart: "auto", fontSize: 11, color: "var(--muted)" }}>
          {loading ? "⏳ جارٍ التحميل..." : `${items.length} سجل`}
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflowX: "auto" }}>
        {items.length === 0 && !loading ? (
          <div style={{ padding: 20, textAlign: "center", color: "var(--muted)", fontSize: 12 }}>
            لا توجد سجلات لهذا النوع من الأحداث.
          </div>
        ) : (
          <table style={{ width: "100%", fontSize: 11.5, borderCollapse: "collapse" }}>
            <thead style={{ background: "var(--beige)" }}>
              <tr>
                <th style={tableHead}>التاريخ والوقت</th>
                <th style={tableHead}>الحدث</th>
                <th style={tableHead}>المُنفِّذ</th>
                <th style={tableHead}>الدور</th>
                <th style={tableHead}>المتأثَّر/التفاصيل</th>
                <th style={tableHead}>IP</th>
              </tr>
            </thead>
            <tbody>
              {items.map((e, i) => {
                const meta = e.meta || {};
                const target = meta.target_username || meta.deleted_user || meta.new_user || meta.username || "—";
                const fields = (meta.fields || []).join(", ");
                return (
                  <tr key={i} style={{ borderTop: "1px solid var(--border)" }}>
                    <td style={tableCell}>{(e.ts || "").slice(0, 16).replace("T", " ")}</td>
                    <td style={{ ...tableCell, fontWeight: 700, color: eventColor(e.event) }}>{eventLabel(e.event)}</td>
                    <td style={tableCell}>{e.username || "—"}</td>
                    <td style={tableCell}>{e.role || "—"}</td>
                    <td style={{ ...tableCell, fontSize: 11 }}>
                      <div style={{ fontWeight: 700 }}>{target}</div>
                      {fields && <div style={{ color: "var(--muted)", fontSize: 10.5 }}>الحقول: {fields}</div>}
                      {meta.password_changed && <div style={{ color: "#dc2626", fontSize: 10.5 }}>🔐 تم تغيير كلمة السر</div>}
                      {meta.reason && <div style={{ color: "var(--muted)", fontSize: 10.5 }}>{meta.reason}</div>}
                    </td>
                    <td style={{ ...tableCell, fontFamily: "monospace", fontSize: 10.5 }}>{e.ip || "—"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function eventLabel(ev) {
  const map = {
    "user.updated": "✏ تعديل مستخدم",
    "user.created": "➕ إضافة مستخدم",
    "user.deleted": "🗑 حذف مستخدم",
    "login.success": "🟢 دخول ناجح",
    "login.failed":  "🔴 دخول فاشل",
  };
  return map[ev] || ev || "—";
}
function eventColor(ev) {
  if (ev === "user.deleted" || ev === "login.failed") return "#dc2626";
  if (ev === "user.created" || ev === "login.success") return "#16a34a";
  if (ev === "user.updated") return "#d97706";
  return "var(--brown-deep)";
}

export default AuditLogPanel;
